var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.746094,
    width: 32,
    height: 32,
    fill: "url(#pattern0_19_398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_19_398",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_19_398",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_19_398",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADEUlEQVR4nO3dwYuNYRTH8YOQJCmRUkQpysJGUSgW7NjOLGdmObYzW3ZmZjm2M8uZWY5Z2ViwUKhRFopSitREk6QJ4asnV6YMz8289zznPO/5/AXnd85tbnPf8zyvSAghhBBCCCGEEEIIDQP2Ax+xbwU4UN0HAJjFjxmpCXAK+I4vZ6QGwEbgIf4sptrFO2AQvwbEM2AH8Aa/loCd4hUwhn9j4hFwGPiEf5+BI+INcIt6zIsnwHnqc1E8ADYBT6jPU2CzWAdcpV7DYhmwC3hHvZaB3WIVcJP6TYpFwDHgC/X7ChwXa4DbtMcdsQS4opVc8rVouSwWAFuA51qpJV+PlhfAVp0u/zvwqGJouqhH06hOl/8edi/wXjOx5GvS9AHYp9PttcNOKwemi5q0Tet0+8+gJ4Bv2mklX5e21IOTOl3/HXIDcK9AWLqorYT7qSc63f8Zsr9QULqorZR+reZvA16WSil2B/Aa2K4xgOsFQ2J4AMm16rfbxPYA0lbdwV4OYK5wQIwPIJnrVfNPW9huE/sDSM71YrvtEQaIjwE8To9mmxzAEEaIjwEkQ1Vut4mfATSzVQdMYIj4GUAyUd12m/gawPq26oAFjBFfA0gW/rf5FzBI/A0guRQD8DYAqwu20pY/QZ0w8SVcerUdGMcQyddryfi6mm/xH7FWHm9yftCulMFGmu/8qGnJI67N/Rhn6edoJ8422nyn1w2UMtuT5lt5JEnbL/pID55LpzSstw/lLaylGPZKZS2lM4S+UiklX1spfSrNXxX0bomUkq+r/tXETtBYzi21nLtqCFMok3xN2qZ0ur122D1xQINyBzQ6QxjR/LhJvh5NIzpdzh/Se6aVWPL1tOuQXpKObGqllnwt7Tqm+ksc1C4MOBpXFRSWLrKgfpNi/Lqat9Rr2fR1NUm61Ih6DYt1cWWZAXFpnwHpqkfqMS/eAIesrba36uLWBLiBf2PiVQVbdUuuL+9O0hXw+DUg3nW26h7gz2IVL3BI4hUmBqQX4+DHjNTG0VbdSpWvsQohhBBCCCGEEEIIUtoPXE0iryJ0wKQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpam);
export default __webpack_public_path__ + "static/media/Spam.e63402f8b395ff5a04a1237f2a08d2ae.svg";
export { ForwardRef as ReactComponent };